module.exports = __webpack_public_path__ + "static/media/question.310ca6ee.mp3";